import { useEffect } from 'react'
import { useAuth, useClerk } from '@clerk/clerk-react'
import { resetTokenBridge, setAuthFailureHandler, setTokenGetter } from '../tokenBridge'

export default function AuthBridge() {
  const { getToken } = useAuth()
  const { signOut } = useClerk()

  useEffect(() => {
    setTokenGetter(() => getToken())

    setAuthFailureHandler(async () => {
      const returnUrl = window.location.pathname + window.location.search

      await signOut()

      window.location.replace(`/sign-in?redirect_url=${encodeURIComponent(returnUrl)}`)
    })

    return () => {
      resetTokenBridge()
    }
  }, [getToken, signOut])

  return null
}
